import { IAutomationObject } from '../../automationObjects';
// api
import {   DeleteRelationsCommand,  useDeleteRelationMutation } from '../../services/objects';
import { IDashboardCollection } from '../../features/Dashboard/types';


function useRemoveDashboardItem(): any {

    const [deleteRelation, deleteRelationResult] = useDeleteRelationMutation();


    function remove(dashboard: IDashboardCollection, app: IAutomationObject) {
        const cmd: DeleteRelationsCommand = {
            fromObjectId: dashboard.id,
            toObjectId: app.id,
            type: 'Includes',
            resourceGroupId: dashboard.resourceGroupId
        }
        deleteRelation(cmd);
    }
    const result = deleteRelationResult;
    return [remove, result]
}

export default useRemoveDashboardItem